import { Component } from "react";

// Contains render crashes so one bad record can't blank an entire page.
// `fallback(error, reset)` lets callers render a scoped message.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    // Reset when the caller swaps what's being rendered (e.g. new personId).
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error, this.reset);
      return (
        <div className="p-6 text-center text-slate-300" data-testid="error-boundary">
          <div className="text-sm">Something went wrong loading this view.</div>
          <div className="text-[11px] text-slate-500 mt-1 font-mono break-all">
            {String(this.state.error?.message || this.state.error)}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
